(() => {
  document.querySelectorAll('[data-pg-legacy]').forEach(body => {
    const title = body.closest('[data-pino-guide]')?.querySelector('.pg-heading h1');
    const heading = body.querySelector('h1,h2,h3');
    const normalize = value => value.replace(/[\s\u200b]+/g, '').trim();
    if (heading && title && normalize(heading.textContent) === normalize(title.textContent)) heading.remove();
    body.querySelectorAll('a').forEach(link => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.origin); } catch { return; }
      if (!['pinostudio-photo.jp', 'pinostudio-new.myshopify.com'].includes(url.hostname)) return;
      let path;
      try { path = decodeURIComponent(url.pathname); } catch { return; }
      const support = ['/pages/question','/pages/f-a','/pages/line','/pages/consultationquestion','/pages/法人のお客様'];
      if (support.includes(path)) link.setAttribute('href', '/pages/inquiry_240406');
      if (['/pages/guarantee','/pages/30日間返品無料保証のコピー','/pages/regulation'].includes(path)) link.setAttribute('href', '/policies/refund-policy');
    });
  });
})();
